export default {
  userCookie: import.meta.env.VITE_TRACKING_USER_COOKIE,
  authenticatedUserCookie: import.meta.env.VITE_TRACKING_AUTHENTICATED_USER_COOKIE
}
